import crud_actions from '../crud_actions'

export const loadOnboardingTags = crud_actions.read('onboardingTags')
